import { BadgePercent, CalendarDaysIcon, MapPinned, UsersRound } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Event } from '@/types/event';
interface EventCardProps {
    event: Event;
    isCarousel?: boolean;
}

const EventCard = ({ event, isCarousel }: EventCardProps) => {
    const t = useTranslations();

    const showedInfo = [
        {
            id: 'calendar',
            icon: CalendarDaysIcon,
            text: event.expires_at,
        },
        {
            id: 'map',
            icon: MapPinned,
            text: event.location,
        },
        {
            id: 'users',
            icon: UsersRound,
            text: event.type.title,
        },
        {
            id: 'badge',
            icon: BadgePercent,
            text: event.payment_type,
        },
    ];
    return (
        <div className={cn('group relative h-[300px] w-full cursor-pointer overflow-hidden md:h-[364px] md:w-[384px]')}>
            <Image src={event.image} alt={event.title} fill className='object-cover' />

            {isCarousel ? (
                <>
                    <div className='absolute inset-0 bg-gradient-to-t from-black/30 from-0% via-5% to-transparent to-100%' />
                    <div className='absolute inset-x-0 bottom-4 left-4 flex flex-col gap-2'>
                        <h3 className='font-gilroy align-middle  text-[24px] font-extrabold leading-[100%] tracking-[-0.012em] text-white'>
                            {event.title}
                        </h3>
                        <p className='font-gilroy align-middle text-[16px] font-medium leading-[100%] tracking-[-0.012em] text-white'>
                            {event.category.title}
                        </p>
                    </div>
                </>
            ) : (
                <Link href={`/events/${event.id}`}>
                    <div className='bg-purple-royal absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-80'></div>
                    <div className='z-10 block opacity-100 transition-opacity duration-300 group-hover:opacity-0'>
                        {event.status && (
                            <div className='bg-purple-alpha absolute left-4 top-4 p-2 '>
                                <p className='font-gilroy align-middle text-base font-medium leading-[100%] tracking-normal text-white'>
                                    {event.status}
                                </p>
                            </div>
                        )}

                        <div className='absolute inset-0 bg-gradient-to-t from-black/30 from-0% via-5% to-transparent to-100%' />
                        <div className='absolute inset-x-0 bottom-4 left-4 flex flex-col gap-2'>
                            <h3 className='font-gilroy align-middle  text-[24px] font-extrabold leading-[100%] tracking-[-0.012em] text-white'>
                                {event.title}
                            </h3>
                            <p className='font-gilroy align-middle text-[16px] font-medium leading-[100%] tracking-[-0.012em] text-white'>
                                {event.category.title}
                            </p>
                        </div>
                    </div>
                    <div className='absolute inset-0 z-10 flex flex-col gap-3 p-4 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100 md:gap-6'>
                        <h3 className='font-gilroy line-clamp-2 h-[66px] min-h-[66px] overflow-hidden align-middle text-2xl text-[24px] font-extrabold'>
                            {event.title}
                        </h3>
                        {showedInfo.map(info => {
                            return (
                                <div key={info.id} className='flex items-center gap-2'>
                                    <info.icon className='size-6 min-w-6' />
                                    <p className='font-gilroy truncate align-middle text-base font-medium leading-[22px] tracking-normal'>
                                        {info.text}
                                    </p>
                                </div>
                            );
                        })}
                        <div>
                            <Button className='bg-red-coral hover:bg-opacity/80 font-gilroy rounded-none px-4 py-[14px] text-center align-middle text-base font-extrabold leading-[100%] tracking-normal text-white transition-colors'>
                                {t('view-more')}
                            </Button>
                        </div>
                    </div>
                </Link>
            )}
        </div>
    );
};

export default EventCard;
